import React, { Component, lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import Layout from "../../Layout/Layout";
import AuthRouter from "./AuthRouter";
import CircleLoader from "react-spinners/CircleLoader";

const routes = [
    {
        path: '/',
        Component: lazy(() => import('../../../page/Treatment/Treatment')),
        exact: true,
    },
    {
        path: '/about',
        Component: lazy(() => import('../../../page/About/About')),
        exact: true,
    },
    {
        path: '/contact',
        Component: lazy(() => import('../../../page/Contact/Contact')),
        exact: true,
    }
]
class Router extends Component {

    constructor({ match }) {
        super();
        this.path = match
    }
    render() {
        return (
            <div>
                <Suspense fallback={<div className="loader">
                    <CircleLoader size={50} color="#157160" />
                </div>}>
                    <Switch>
                        {
                            routes.map((route, idx) => (
                                <Route exact={route.exact} key={idx} path={`${route.path}`}>
                                    <Layout>
                                        <route.Component />
                                    </Layout>
                                </Route>
                            ))
                        }
                        <Route component={AuthRouter} />
                    </Switch>
                </Suspense>
            </div>
        )
    }
}

export default Router;